/**
 * @desc 获取商户下该付款人支付方式下最近几笔交易
 */

import * as defs from '../../baseClass'
import axios from '@/services/request'

export class Params {
  /** paymentCode */
  paymentCode: string
}

export const init = new defs.SimpleResponse()

export async function request(params) {
  return axios({
    url: '/api/scp-cashier-business/payment/latestPaymentList',
    params,
    method: 'get',
  })
}
